import { render, staticRenderFns } from "./TopAgentRenewCards.vue?vue&type=template&id=00ed72df&"
import script from "./TopAgentRenewCards.vue?vue&type=script&lang=js&"
export * from "./TopAgentRenewCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports